import qs from "query-string";
export var contentTypes = {
  json: {
    header: "application/json",
    stringify: function stringify(data) {
      return JSON.stringify(data);
    }
  },
  form: {
    header: "application/x-www-form-urlencoded",
    stringify: function stringify(data) {
      return qs.stringify(data);
    }
  },
  none: {
    header: undefined,
    stringify: function stringify() {
      return undefined;
    }
  }
};